import { BuilderAgentConversation, BuilderAgentAuthor } from 'features/builder/types'

export const GENAI_LOCATION_ZOOM_LEVEL_ON_ADD = 10 // Zoom level when adding a single marker
export const GENAI_LOCATION_ZOOM_LEVEL_ON_CLICK = 17 // Zoom level when clicking a location chip
export const MAX_VISIBLE_LOCATIONS = 3

export interface LocationWithNumber {
  geometry: GeoJSON.Point
  label: string
  locationNumber: number
}

/**
 * Calculates location numbers for all Agent locations in the conversation.
 * Numbers are assigned sequentially to non-removed locations.
 * Removed locations are excluded from the numbering sequence.
 */
export function calculateGenAiLocationNumbers(conversation: BuilderAgentConversation): LocationWithNumber[] {
  const locationsWithNumbers: LocationWithNumber[] = []
  let locationCounter = 0

  for (const item of conversation) {
    if (item.author === BuilderAgentAuthor.User && item.locations && item.locations.length > 0) {
      for (const location of item.locations) {
        if (!location.removed) {
          locationCounter++
          locationsWithNumbers.push({
            geometry: location.geometry,
            label: location.label,
            locationNumber: locationCounter
          })
        }
      }
    }
  }

  return locationsWithNumbers
}

/**
 * Counts the number of non-removed locations in all messages before the specified message index.
 * This count is used as the starting location number for the message at the given index.
 */
export function countNonRemovedLocationsBeforeMessage(
  conversation: BuilderAgentConversation,
  messageIndex: number
): number {
  return conversation.slice(0, messageIndex).reduce((count, ci) => {
    if (ci.author === BuilderAgentAuthor.User && ci.locations) {
      return count + ci.locations.filter((loc) => !loc.removed).length
    }
    return count
  }, 0)
}
